import axios from "axios";
export async function isAnonymizationEnabled() {
    const response = await axios.get('/api/workflow/requester/anonymizationEnabled');
    return response.data;
}
